import { TPinStyles } from './types'

export const pinStyles: TPinStyles = {
  notification: { status: 'DANGER', direction: 'LEFT' },
  inactive: { iconName: 'close', status: 'DANGER', direction: 'RIGHT' },
  checked: { iconName: 'checked', status: 'SUCCESS', direction: 'LEFT' },
}
